import { IFederatedStateCodes, Maybe } from 'types/graphqlTypes'
import { mapStateNameToAbbr } from 'utils/countriesStates'

interface ILocation {
  /**
   * @example 'Miami'
   */
  city: string
  /**
   * @example 'FL'
   */
  stateCode: string
}

/**
 * Parses the city and state from a location string
 * @example parseLocation('Miami, Florida, United States') // { city: 'Miami', state: 'FL' }
 */
export const parseLocation = (location: Maybe<string>): Maybe<ILocation> => {
  if (!location) {
    return null
  }

  const [city, state] = location.split(',') || []

  if (!city || !state) {
    return null
  }

  const federatedStateCodes = Object.values(IFederatedStateCodes).map(stateCode => `${stateCode}`)

  const stateTrimmed = state.trim()
  const stateCode = federatedStateCodes.includes(stateTrimmed)
    ? stateTrimmed
    : mapStateNameToAbbr(stateTrimmed)

  return {
    city: city.trim(),
    stateCode: stateCode || '',
  }
}
